class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (event.state && Object.prototype.hasOwnProperty.call(event.state, 'availabilityOverride')) {
        FacetFiltersForm.pendingAvailabilityOverride = event.state.availabilityOverride;
      } else {
        FacetFiltersForm.pendingAvailabilityOverride = undefined;
      }
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    console.log('toggleしようとしている')
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    
    // desktop-split-layoutの構造を保護
    const splitLayout = document.querySelector('.desktop-split-layout');
    const rightPanel = document.querySelector('.desktop-right-panel');
    if (!splitLayout || !rightPanel) {
      console.warn('[DEBUG] renderPage: desktop-split-layout structure not found, skipping loading state update');
      return;
    }
    
    const productGridContainer = document.getElementById('ProductGridContainer');
    if (productGridContainer) {
      const collection = productGridContainer.querySelector('.collection');
      if (collection) {
        collection.classList.add('loading');
      }
    }
    
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    const container = document.getElementById('ProductGridContainer');
    if (!container) return;
    
    // desktop-split-layoutの構造を保護
    const splitLayout = document.querySelector('.desktop-split-layout');
    const rightPanel = document.querySelector('.desktop-right-panel');
    if (!splitLayout || !rightPanel) {
      console.warn('desktop-split-layout structure not found, skipping ProductGridContainer update');
      return;
    }
    
    // レイアウトシフトを防ぐため、最小高さを保持
    const minHeight = container.offsetHeight || 400;
    container.style.minHeight = minHeight + 'px';
    
    // DOM構造を保護するため、requestAnimationFrameで実行
    requestAnimationFrame(() => {
      // desktop-split-layoutの構造がまだ存在するか再確認
      const checkSplitLayout = document.querySelector('.desktop-split-layout');
      const checkRightPanel = document.querySelector('.desktop-right-panel');
      if (!checkSplitLayout || !checkRightPanel) {
        console.error('desktop-split-layout structure broken before ProductGridContainer update');
        container.style.minHeight = '';
        return;
      }
      
      const parsedHtml = new DOMParser()
      .parseFromString(html, 'text/html')
        .getElementById('ProductGridContainer');
      
      if (parsedHtml) {
        // desktop-split-layoutの構造を再確認（更新直前）
        const beforeUpdateSplitLayout = document.querySelector('.desktop-split-layout');
        const beforeUpdateRightPanel = document.querySelector('.desktop-right-panel');
        if (!beforeUpdateSplitLayout || !beforeUpdateRightPanel) {
          console.error('desktop-split-layout structure broken before innerHTML update');
          container.style.minHeight = '';
          return;
        }
        
        container.innerHTML = parsedHtml.innerHTML;
        
        // desktop-split-layoutの構造を再確認（更新直後）
        const afterUpdateSplitLayout = document.querySelector('.desktop-split-layout');
        const afterUpdateRightPanel = document.querySelector('.desktop-right-panel');
        if (!afterUpdateSplitLayout || !afterUpdateRightPanel) {
          console.error('desktop-split-layout structure broken after innerHTML update');
        }
      }

    document
      .getElementById('ProductGridContainer')
        ?.querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
        });
      
      // レンダリング後に最小高さをリセット
      requestAnimationFrame(() => {
        if (container) {
          container.style.minHeight = '';
        }
        
        // desktop-split-layoutの構造が壊れていないか確認
        const finalSplitLayout = document.querySelector('.desktop-split-layout');
        const finalRightPanel = document.querySelector('.desktop-right-panel');
        if (!finalSplitLayout || !finalRightPanel) {
          console.error('desktop-split-layout structure broken after ProductGridContainer update');
        }
      });
      });
  }

  static renderProductCount(html) {
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const countEl = parsed.getElementById('ProductCount');
    if (!countEl) return; // 要素が無い場合は何もしない
    const count = countEl.innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    // desktop-split-layoutの構造を保護
    const splitLayout = document.querySelector('.desktop-split-layout');
    const rightPanel = document.querySelector('.desktop-right-panel');
    if (!splitLayout || !rightPanel) {
      console.warn('desktop-split-layout structure not found, skipping renderFilters');
      return;
    }
    
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const collectFilters = (root) =>
      root
        ? root.querySelectorAll(
            '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter, .mobile-filter-modal__section.js-filter'
          )
        : [];

    let facetDetailsElementsFromFetch = collectFilters(parsedHTML);

    // フォールバック：セクションHTML内にtemplateだけがあり、直接DOMにjs-filterが無いケース
    if (!facetDetailsElementsFromFetch || facetDetailsElementsFromFetch.length === 0) {
      const facetsTemplate = parsedHTML.querySelector('#facets-template');
      if (facetsTemplate) {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = facetsTemplate.innerHTML;
        facetDetailsElementsFromFetch = collectFilters(tempDiv);
        console.log('[DEBUG] renderFilters: using filters from template fallback', {
          found: facetDetailsElementsFromFetch.length,
        });
      }
    }

    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter, .mobile-filter-modal__section.js-filter'
    );

    // Remove facets that are no longer returned from the server
    // 取得できていない（空配列）場合は削除をスキップして消失を防ぐ
    if (facetDetailsElementsFromFetch && facetDetailsElementsFromFetch.length > 0) {
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });
    } else {
      console.warn('[DEBUG] renderFilters: facetDetailsElementsFromFetch empty, skip removal to avoid loss');
    }

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      // desktop-split-layoutの構造を再確認（各要素処理前）
      const checkSplitLayout = document.querySelector('.desktop-split-layout');
      const checkRightPanel = document.querySelector('.desktop-right-panel');
      if (!checkSplitLayout || !checkRightPanel) {
        console.error(`[DEBUG] renderFilters: structure broken before processing element ${index}`);
        return;
      }
      
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        console.log(`[DEBUG] renderFilters: updating innerHTML for ${elementToRender.id}`);
        currentElement.innerHTML = elementToRender.innerHTML;
      } else {
        // モーダル内のフィルターセクションの場合は、data-filter-panelで検索
        if (elementToRender.classList.contains('mobile-filter-modal__section')) {
          const filterPanel = elementToRender.dataset.filterPanel;
          if (filterPanel) {
            const existingSection = document.querySelector(`.mobile-filter-modal__section[data-filter-panel="${filterPanel}"]`);
            if (existingSection) {
              existingSection.innerHTML = elementToRender.innerHTML;
              return;
            }
          }
        }
        
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            console.log(`[DEBUG] renderFilters: adding after ${previousElementId}`);
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          const parentElement = elementToRender.parentElement;
          const parentElementId = parentElement.id;
          console.log(`[DEBUG] renderFilters: adding before parent ${parentElementId}`);

          if (parentElementId) {
            const parentFilter = document.querySelector(`#${CSS.escape(parentElementId)} .js-filter`);
            if (parentFilter) {
              parentFilter.before(elementToRender);
              return;
            }
          }

          // parentElement.id が空のケース（例: .mobile-filter-modal__content）では
          // 親クラスを使って既存DOM上の挿入先を解決する
          const parentClassList = Array.from(parentElement.classList || []);
          const parentClassSelector = parentClassList.length
            ? `.${parentClassList.map((className) => CSS.escape(className)).join('.')}`
            : '';

          if (parentClassSelector) {
            const parentFromDom = document.querySelector(parentClassSelector);
            if (parentFromDom) {
              const firstFilterInParent = parentFromDom.querySelector('.js-filter');
              if (firstFilterInParent) {
                firstFilterInParent.before(elementToRender);
                return;
              }
              parentFromDom.append(elementToRender);
            }
          }
        }
      }
      
      // desktop-split-layoutの構造を再確認（各要素処理後）
      const afterCheckSplitLayout = document.querySelector('.desktop-split-layout');
      const afterCheckRightPanel = document.querySelector('.desktop-right-panel');
      if (!afterCheckSplitLayout || !afterCheckRightPanel) {
        console.error(`[DEBUG] renderFilters: structure broken after processing element ${index}`);
      }
    });

    FacetFiltersForm.renderAdditionalElements(parsedHTML);
    // renderAdditionalElementsの後にrenderActiveFacetsを呼ぶことで、active-facetsが最後に更新され、上書きされないようにする
    // setTimeoutで少し遅延させて、確実に更新されるようにする
    setTimeout(() => {
      FacetFiltersForm.renderActiveFacets(parsedHTML);
    }, 0);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    // シンプルに：サーバーから返されたHTMLのactive-facetsをそのまま使用
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    console.log('[DEBUG] renderActiveFacets called', {
      htmlString: html.constructor.name,
      hasActiveFacetsMobile: !!html.querySelector('.active-facets-mobile'),
      hasActiveFacetsDesktop: !!html.querySelector('.active-facets-desktop')
    });

    activeFacetElementSelectors.forEach((selector) => {
      let activeFacetsElement = html.querySelector(selector);
      
      // テンプレート内にある場合のフォールバック
      if (!activeFacetsElement) {
        const facetsTemplate = html.querySelector('#facets-template');
        if (facetsTemplate) {
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = facetsTemplate.innerHTML;
          activeFacetsElement = tempDiv.querySelector(selector);
          console.log('[DEBUG] renderActiveFacets fallback to template', {
            selector,
            foundInTemplate: !!activeFacetsElement,
          });
        }
      }

      const targetElement = document.querySelector(selector);
      
      console.log('[DEBUG] renderActiveFacets processing', {
        selector,
        hasSource: !!activeFacetsElement,
        hasTarget: !!targetElement,
        sourceHTML: activeFacetsElement ? activeFacetsElement.innerHTML.substring(0, 100) : null,
        targetHTML: targetElement ? targetElement.innerHTML.substring(0, 100) : null
      });
      
      if (!targetElement) return;
      
      if (!activeFacetsElement) {
        // ソースが無い場合は既存UIを保持（空にしない）
        console.log('[DEBUG] renderActiveFacets: no source element, keeping existing UI');
        return;
      }
      
      // サーバーから返されたHTMLをそのまま使用
      const sourceHTML = activeFacetsElement.innerHTML;
      console.log('[DEBUG] renderActiveFacets updating', {
        selector,
        sourceHTMLLength: sourceHTML.length,
        targetHTMLLength: targetElement.innerHTML.length,
        facetRemoveCount: (sourceHTML.match(/facet-remove/g) || []).length
      });
      targetElement.innerHTML = sourceHTML;
      
      // facet-remove要素を再初期化（innerHTML更新後）
      const facetRemoveElements = targetElement.querySelectorAll('facet-remove');
      facetRemoveElements.forEach((element) => {
        const facetLink = element.querySelector('a');
        if (!facetLink) return;
        
        // 既存のイベントリスナーを削除して再設定
        const newLink = facetLink.cloneNode(true);
        facetLink.parentNode.replaceChild(newLink, facetLink);
        
        if (customElements.get('facet-remove')) {
          customElements.upgrade(element);
        }
        
        newLink.setAttribute('role', 'button');
        const clickHandler = (event) => {
          event.preventDefault();
          const paramName = element.dataset.facetParam || newLink.dataset.facetParam;
          const facetAction = element.dataset.facetAction || newLink.dataset.facetAction;
          if (paramName && paramName.includes('availability')) {
            FacetFiltersForm.pendingAvailabilityOverride = false;
            FacetFiltersForm.currentAvailabilityOverride = false;
          } else if (facetAction === 'clear-all') {
            FacetFiltersForm.pendingAvailabilityOverride = false;
            FacetFiltersForm.currentAvailabilityOverride = false;
            resetMobileAvailabilityCheckbox();
          }
          const form = element.closest('facet-filters-form') || document.querySelector('facet-filters-form');
          if (form && typeof form.onActiveFilterClick === 'function') {
            form.onActiveFilterClick(event);
          }
        };
        newLink.addEventListener('click', clickHandler);
        newLink.addEventListener('keyup', (event) => {
          if (event.code.toUpperCase() === 'SPACE') {
            event.preventDefault();
            clickHandler(event);
          }
        });
      });
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const sortingElement = html.querySelector('.sorting');
    const sortingTarget = document.querySelector('.sorting');
    if (sortingElement && sortingTarget) {
      sortingTarget.innerHTML = sortingElement.innerHTML;
    }

    let mobileModalState;
    const mobileFacetsContainer = document.querySelector('[data-mobile-facets]');
    if (mobileFacetsContainer) {
      const currentTabs = mobileFacetsContainer.querySelector('.mobile-filter-tabs');
      const currentModal = mobileFacetsContainer.querySelector('[data-mobile-filter-modal]');
      const currentModalTabs = currentModal
        ? currentModal.querySelector('.mobile-filter-modal__tabs')
        : null;

      let activeFilterHandle =
        (currentTabs && currentTabs.dataset.activeFilter) ||
        (currentModalTabs && currentModalTabs.dataset.activeFilter);

      if (!activeFilterHandle) {
        const activeSection = currentModal
          ? currentModal.querySelector('.mobile-filter-modal__section.is-active')
          : null;
        const activeTab = mobileFacetsContainer.querySelector('.mobile-filter-tab--active');
        activeFilterHandle =
          (activeSection && activeSection.dataset.filterPanel) ||
          (activeTab && activeTab.dataset.filterTarget) ||
          activeFilterHandle;
      }

      if (currentModal || activeFilterHandle) {
        mobileModalState = {
          activeFilter: activeFilterHandle,
          isOpen: currentModal ? currentModal.classList.contains('is-open') : false,
        };
      }
    }

    if (FacetFiltersForm.pendingMobileModalState) {
      mobileModalState = mobileModalState || {};
      const pendingModalState = FacetFiltersForm.pendingMobileModalState;
      if (pendingModalState.activeFilter) {
        mobileModalState.activeFilter = pendingModalState.activeFilter;
      }
      if (Object.prototype.hasOwnProperty.call(pendingModalState, 'isOpen')) {
        mobileModalState.isOpen = pendingModalState.isOpen;
      }
    }

    if (mobileFacetsContainer && typeof mobileFacetsContainer.__mobileFilterCleanup === 'function') {
      const keepOpen = Boolean(mobileModalState && mobileModalState.isOpen);
      mobileFacetsContainer.__mobileFilterCleanup({ keepOpen });
      mobileFacetsContainer.__mobileFilterCleanup = undefined;
    }

    // mobile-filter-meta（ソートと販売中のみ表示）を更新
    const mobileFilterMetaSource = html.querySelector('.mobile-filter-meta');
    const mobileFilterMetaTarget = document.querySelector('.mobile-filter-meta');
    if (mobileFilterMetaSource && mobileFilterMetaTarget) {
      // チェックボックスの状態を保存
      const currentCheckbox = mobileFilterMetaTarget.querySelector('.mobile-filter-availability__checkbox');
      const currentChecked = currentCheckbox ? currentCheckbox.checked : false;
      
      mobileFilterMetaTarget.innerHTML = mobileFilterMetaSource.innerHTML;
      
      // チェックボックスの状態を復元
      const newCheckbox = mobileFilterMetaTarget.querySelector('.mobile-filter-availability__checkbox');
      if (newCheckbox && typeof FacetFiltersForm.pendingAvailabilityOverride === 'boolean') {
        newCheckbox.checked = FacetFiltersForm.pendingAvailabilityOverride;
      } else if (newCheckbox) {
        newCheckbox.checked = currentChecked;
      }
      
      // イベントリスナーを再設定
      if (newCheckbox) {
        const availabilityOption = newCheckbox.closest('.mobile-filter-availability__option');
        if (availabilityOption) {
          availabilityOption.classList.toggle('is-active', newCheckbox.checked);
        }
        
        newCheckbox.addEventListener('change', () => {
          const option = newCheckbox.closest('.mobile-filter-availability__option');
          if (option) {
            option.classList.toggle('is-active', newCheckbox.checked);
          }
          FacetFiltersForm.currentAvailabilityOverride = newCheckbox.checked;
        });
      }
    }

    // mobile-filter-tabs（フィルター条件リスト）を更新
    const mobileFilterTabsSource = html.querySelector('.mobile-filter-tabs');
    const mobileFilterTabsTarget = document.querySelector('.mobile-filter-tabs');
    if (mobileFilterTabsSource && mobileFilterTabsTarget) {
      mobileFilterTabsTarget.innerHTML = mobileFilterTabsSource.innerHTML;
      // data属性も更新
      if (mobileFilterTabsSource.dataset.firstFilter) {
        mobileFilterTabsTarget.dataset.firstFilter = mobileFilterTabsSource.dataset.firstFilter;
      }
      if (mobileFilterTabsSource.dataset.activeFilter) {
        mobileFilterTabsTarget.dataset.activeFilter = mobileFilterTabsSource.dataset.activeFilter;
      }
    }

    // mobile-filter-modal__contentはrenderFiltersで更新済み（モーダル内のセクションを個別に更新）

    // mobile-filter-modal__tabs（モーダル内のタブ）を更新
    const mobileModalTabsSource = html.querySelector('.mobile-filter-modal__tabs');
    const mobileModalTabsTarget = document.querySelector('.mobile-filter-modal__tabs');
    if (mobileModalTabsSource && mobileModalTabsTarget) {
      mobileModalTabsTarget.innerHTML = mobileModalTabsSource.innerHTML;
      // data属性も更新
      if (mobileModalTabsSource.dataset.firstFilter) {
        mobileModalTabsTarget.dataset.firstFilter = mobileModalTabsSource.dataset.firstFilter;
      }
      if (mobileModalTabsSource.dataset.activeFilter) {
        mobileModalTabsTarget.dataset.activeFilter = mobileModalTabsSource.dataset.activeFilter;
      }
    }


    // availabilityCheckboxはmobile-filter-meta更新時に既に設定済み
    // ここでは状態のみを更新
    const availabilityCheckbox = document.querySelector(
      '[data-mobile-facets] .mobile-filter-availability__checkbox'
    );

    FacetFiltersForm.currentAvailabilityOverride = availabilityCheckbox
      ? availabilityCheckbox.checked
      : undefined;
    FacetFiltersForm.pendingAvailabilityOverride = undefined;

    // facet-remove要素を再初期化（innerHTML更新後に必要）
    // innerHTMLで更新するたびに要素が再作成されるため、毎回再初期化が必要
    // requestAnimationFrameでDOM更新を待ってから実行
    requestAnimationFrame(() => {
      const facetRemoveElements = document.querySelectorAll('facet-remove');
      facetRemoveElements.forEach((element) => {
        const facetLink = element.querySelector('a');
        if (!facetLink) return;
        
        // 既にイベントリスナーが設定されているか確認
        if (facetLink.hasAttribute('data-listener-attached')) {
          return;
      }

        // カスタム要素を手動でアップグレード
        if (customElements.get('facet-remove')) {
          customElements.upgrade(element);
        }
        
        // イベントリスナーを手動で設定
        facetLink.setAttribute('role', 'button');
        const clickHandler = (event) => {
          event.preventDefault();
          event.stopPropagation();
          const paramName = element.dataset.facetParam || facetLink.dataset.facetParam;
          const facetAction = element.dataset.facetAction || facetLink.dataset.facetAction;
          if (paramName && paramName.includes('availability')) {
            FacetFiltersForm.pendingAvailabilityOverride = false;
            FacetFiltersForm.currentAvailabilityOverride = false;
          } else if (facetAction === 'clear-all') {
            FacetFiltersForm.pendingAvailabilityOverride = false;
            FacetFiltersForm.currentAvailabilityOverride = false;
            resetMobileAvailabilityCheckbox();
          }
          const form = element.closest('facet-filters-form') || document.querySelector('facet-filters-form');
          if (form && typeof form.onActiveFilterClick === 'function') {
            form.onActiveFilterClick(event);
          }
        };
        facetLink.addEventListener('click', clickHandler);
        facetLink.addEventListener('keyup', (event) => {
          if (event.code.toUpperCase() === 'SPACE') {
            event.preventDefault();
            clickHandler(event);
          }
        });
        facetLink.setAttribute('data-listener-attached', 'true');
      });
    });

    // モーダルのコンテンツとタブを更新した後、少し遅延してから初期化（DOM更新を確実にするため）
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        // DOM更新後の実際のモーダル状態を確認
        const updatedModal = document.querySelector('[data-mobile-filter-modal]');
        const finalModalState = mobileModalState ? { ...mobileModalState } : {};
        
        // フィルター適用後はモーダルを閉じる（pendingMobileModalStateが設定されていた場合）
        if (FacetFiltersForm.pendingMobileModalState && FacetFiltersForm.pendingMobileModalState.isOpen) {
          // フィルター適用が完了したので、モーダルを閉じる
          finalModalState.isOpen = false;
        } else if (updatedModal) {
          // DOM更新後の実際の状態を反映
          finalModalState.isOpen = updatedModal.classList.contains('is-open');
        } else if (mobileModalState) {
          // モーダル要素が存在しない場合は閉じた状態
          finalModalState.isOpen = false;
        }
        
        initializeMobileFilterModal(finalModalState);
      });
    });
    FacetFiltersForm.pendingMobileModalState = null;
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      // DEBUG: 続きを見るボタンの処理をコメントアウト
      // const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      // if (isShowingMore) {
      //   sourceWrapElement
      //     .querySelectorAll('.facets__item.hidden')
      //     .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      // }

      // DEBUG: outerHTMLの更新をコメントアウトして短縮処理を無効化
      // targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
      console.log('[DEBUG] renderCounts: outerHTML update skipped to prevent show-more-item processing');
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState(
      {
        searchParams,
        availabilityOverride: FacetFiltersForm.currentAvailabilityOverride,
      },
      '',
      `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`
    );
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    const target = event.target;
    const interactedSection = target.closest('.mobile-filter-modal__section');
    if (interactedSection) {
      const currentModal = target.closest('[data-mobile-filter-modal]');
      let activeHandle = interactedSection.dataset.filterPanel;
      if (!activeHandle && currentModal) {
        const activeTab = currentModal.querySelector('.mobile-filter-modal__tab--active');
        if (activeTab) {
          activeHandle = activeTab.dataset.filterTarget;
        }
      }
      const pendingState = {
        isOpen: true,
        activeFilter: activeHandle,
      };
      FacetFiltersForm.pendingMobileModalState = pendingState;
    } else {
      FacetFiltersForm.pendingMobileModalState = null;
    }

    const mobileAvailabilityCheckbox = document.querySelector(
      '[data-mobile-facets] .mobile-filter-availability__checkbox'
    );
    if (mobileAvailabilityCheckbox) {
      FacetFiltersForm.pendingAvailabilityOverride = mobileAvailabilityCheckbox.checked;
      FacetFiltersForm.currentAvailabilityOverride = mobileAvailabilityCheckbox.checked;
    } else {
      FacetFiltersForm.pendingAvailabilityOverride = undefined;
      FacetFiltersForm.currentAvailabilityOverride = undefined;
    }

    const isInstantMobileCheckbox =
      target.classList &&
      (target.classList.contains('mobile-facets__checkbox') ||
        target.classList.contains('mobile-filter-availability__checkbox'));

    if (isInstantMobileCheckbox) {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    console.log('on active filter click')
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
FacetFiltersForm.pendingMobileModalState = null;
FacetFiltersForm.pendingAvailabilityOverride = undefined;
FacetFiltersForm.currentAvailabilityOverride = (() => {
  const checkbox = document.querySelector('[data-mobile-facets] .mobile-filter-availability__checkbox');
  return checkbox ? checkbox.checked : undefined;
})();
const resetMobileAvailabilityCheckbox = () => {
  const checkbox = document.querySelector('[data-mobile-facets] .mobile-filter-availability__checkbox');
  if (!checkbox) return;
  checkbox.checked = false;
  const option = checkbox.closest('.mobile-filter-availability__option');
  if (option) {
    option.classList.remove('is-active');
  }
};
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    console.log('closeFilter!!!!');
    event.preventDefault();
    const facetLink = this.querySelector('a');
    const paramName = this.dataset.facetParam || (facetLink && facetLink.dataset.facetParam);
    const facetAction = this.dataset.facetAction || (facetLink && facetLink.dataset.facetAction);
    if (paramName && paramName.includes('availability')) {
      FacetFiltersForm.pendingAvailabilityOverride = false;
      FacetFiltersForm.currentAvailabilityOverride = false;
    } else if (facetAction === 'clear-all') {
      FacetFiltersForm.pendingAvailabilityOverride = false;
      FacetFiltersForm.currentAvailabilityOverride = false;
      resetMobileAvailabilityCheckbox();
    }
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

function initializeMobileFilterModal(state = {}) {
  const container = document.querySelector('[data-mobile-facets]');
  if (!container) return;
  const modal = container.querySelector('[data-mobile-filter-modal]');
  if (!modal) return;

  if (typeof container.__mobileFilterCleanup === 'function') {
    container.__mobileFilterCleanup();
  }

  const body = document.body;
  const tabsContainer = container.querySelector('.mobile-filter-tabs');
  const modalTabsContainer = modal.querySelector('.mobile-filter-modal__tabs');
  const sections = Array.from(modal.querySelectorAll('.mobile-filter-modal__section'));
  const hasSections = sections.length > 0;

  const firstFilter =
    (tabsContainer && tabsContainer.dataset.firstFilter) ||
    (modalTabsContainer && modalTabsContainer.dataset.firstFilter) ||
    (sections[0] && sections[0].dataset.filterPanel);

  const defaultActive =
    (tabsContainer && tabsContainer.dataset.activeFilter) ||
    (modalTabsContainer && modalTabsContainer.dataset.activeFilter) ||
    firstFilter;
  const initialActive = (state && state.activeFilter) || defaultActive;

  const tabs = Array.from(container.querySelectorAll('.mobile-filter-tab'));
  const modalTabs = Array.from(modal.querySelectorAll('.mobile-filter-modal__tab'));

  const listeners = [];
  const addListener = (element, eventName, handler) => {
    if (!element) return;
    element.addEventListener(eventName, handler);
    listeners.push({ element, eventName, handler });
  };

  const updateActive = (handle) => {
    let resolved = handle;
    if (!resolved || !sections.some((section) => section.dataset.filterPanel === resolved)) {
      resolved = defaultActive || (sections[0] && sections[0].dataset.filterPanel);
    }
    if (!resolved) return;

    tabs.forEach((button) => {
      button.classList.toggle('mobile-filter-tab--active', button.dataset.filterTarget === resolved);
    });
    modalTabs.forEach((button) => {
      button.classList.toggle('mobile-filter-modal__tab--active', button.dataset.filterTarget === resolved);
    });
    sections.forEach((section) => {
      section.classList.toggle('is-active', section.dataset.filterPanel === resolved);
    });
    if (tabsContainer) tabsContainer.dataset.activeFilter = resolved;
    if (modalTabsContainer) modalTabsContainer.dataset.activeFilter = resolved;

    if (tabsContainer) {
      const activeTab = tabs.find((button) => button.dataset.filterTarget === resolved);
      if (activeTab) {
        const containerRect = tabsContainer.getBoundingClientRect();
        const tabRect = activeTab.getBoundingClientRect();
        const isBefore = tabRect.left < containerRect.left;
        const isAfter = tabRect.right > containerRect.right;

        if (isBefore || isAfter) {
          const offset =
            tabRect.left - containerRect.left - tabsContainer.clientWidth / 2 + activeTab.offsetWidth / 2;
          const nextScrollLeft = Math.max(0, tabsContainer.scrollLeft + offset);

          if (typeof tabsContainer.scrollTo === 'function') {
            try {
              tabsContainer.scrollTo({ left: nextScrollLeft, behavior: 'smooth' });
            } catch (error) {
              tabsContainer.scrollLeft = nextScrollLeft;
            }
          } else {
            tabsContainer.scrollLeft = nextScrollLeft;
          }
        }
      }
    }
  };

  const resolveActiveFilterHandle = () => {
    if (modalTabsContainer && modalTabsContainer.dataset.activeFilter) {
      return modalTabsContainer.dataset.activeFilter;
    }
    if (tabsContainer && tabsContainer.dataset.activeFilter) {
      return tabsContainer.dataset.activeFilter;
    }
    const activeModalTab = modalTabs.find((button) =>
      button.classList.contains('mobile-filter-modal__tab--active')
    );
    if (activeModalTab) {
      return activeModalTab.dataset.filterTarget;
    }
    const activeHeaderTab = tabs.find((button) =>
      button.classList.contains('mobile-filter-tab--active')
    );
    if (activeHeaderTab) {
      return activeHeaderTab.dataset.filterTarget;
    }
    const activeSection = sections.find((section) => section.classList.contains('is-active'));
    if (activeSection) {
      return activeSection.dataset.filterPanel;
    }
    return defaultActive;
  };

  const closeModal = (options = {}) => {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    body.classList.remove('mobile-filter-modal-open');
    if (options.persistState) {
      FacetFiltersForm.pendingMobileModalState = {
        activeFilter: resolveActiveFilterHandle(),
        isOpen: false,
      };
    }
  };

  const openModal = (handle) => {
    updateActive(handle);
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    body.classList.add('mobile-filter-modal-open');
  };

  const headerClickHandler = (event) => {
    const tab = event.target.closest('.mobile-filter-tab');
    if (!tab) return;
    event.preventDefault();
    openModal(tab.dataset.filterTarget);
  };
  addListener(container, 'click', headerClickHandler);

  const modalTabsClickHandler = (event) => {
    const tab = event.target.closest('.mobile-filter-modal__tab');
    if (!tab) return;
    event.preventDefault();
    updateActive(tab.dataset.filterTarget);
  };
  addListener(modal, 'click', modalTabsClickHandler);

  modal.querySelectorAll('[data-mobile-filter-dismiss]').forEach((button) => {
    addListener(button, 'click', () => closeModal({ persistState: true }));
  });

  const applyButton = modal.querySelector('[data-mobile-filter-apply]');
  if (applyButton) {
    addListener(applyButton, 'click', () => closeModal({ persistState: true }));
  }

  addListener(modal, 'click', (event) => {
    const clearAllButton = event.target.closest('[data-facet-action="clear-all"]');
    if (!clearAllButton) return;
    closeModal({ persistState: true });
  });

  const keyHandler = (event) => {
    if (event.key === 'Escape' && modal.classList.contains('is-open')) {
      closeModal({ persistState: true });
    }
  };
  document.addEventListener('keyup', keyHandler);

  container.__mobileFilterCleanup = (options = {}) => {
    listeners.forEach(({ element, eventName, handler }) => {
      element.removeEventListener(eventName, handler);
    });
    document.removeEventListener('keyup', keyHandler);
    if (options.keepOpen) {
      modal.setAttribute('aria-hidden', 'false');
    } else {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      body.classList.remove('mobile-filter-modal-open');
    }
  };

  updateActive(initialActive);

  if (state && state.isOpen && hasSections) {
    openModal(initialActive);
  } else {
    closeModal();
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeMobileFilterModal);
} else {
  initializeMobileFilterModal();
}
